import { loadVideo } from '@client/new/helpers/load-video-from-file';
import { UploadFile } from './uploadVideo.model';

export const validateVideoFiles = (
  uploadItems: UploadFile[],
): Promise<Array<UploadFile>> =>
  Promise.all(
    uploadItems.map(async (uploadItem) => {
      const { duration, videoWidth, videoHeight } = await loadVideo(
        uploadItem.file,
      ).then((video) => video);
      if (isClip(duration) && isLandscapeVideo(videoWidth, videoHeight)) {
        return {
          ...uploadItem,
          error:
            'File too short. Landscape videos must be at least 60 seconds long.',
        };
      }
      return uploadItem;
    }),
  );

export const isClip = (duration: number) => duration < 60;
export const isLandscapeVideo = (videoWidth: number, videoHeight: number) =>
  videoWidth > videoHeight;
